import { Instrument, OrderCreateRequest, OrderEntity, OrderStatusEnum, OrderTypeEnum, Portfolio } from "../domain/entities/OrdersEntity";


export const enrichOrder = (
    request: OrderCreateRequest,
    id: string,
    createdAt: Date,
    updatedAt: Date | null,
    context: {
        portfolios?: Portfolio[];
        instruments?: Instrument[];
    }
): OrderEntity | null => {
    const {
        portfolios = [],
        instruments = [],
    } = context;

    const portfolio = portfolios.find((p) => p.id.toString() === request.portfolio);
    const instrument = instruments.find((ins) => ins.id.toString() === request.instrument);

    if (!portfolio || !instrument) return null;

    return {
        id,
        portfolio,
        instrument,
        quantity: request.quantity,
        rate: request.rate,
        value: request.value,
        createdAt,
        updatedAt,
        orderType: request.orderType as OrderTypeEnum,
        status: request.status as OrderStatusEnum,
        confirmNumber: request.confirmNumber,
    };
}


export const mapToFormValues = (entity?: OrderEntity) =>
({
    id: entity?.id.toString() ?? "",
    portfolio: entity?.portfolio?.id.toString() ?? "",
    orderType: entity ? entity.orderType === OrderTypeEnum.COMPRA : true,
    status: entity?.status ?? undefined,
    instrument: entity?.instrument.id.toString() ?? "",
    quantity: entity?.quantity ?? 0,
    rate: entity?.rate ?? 0,
    value: entity?.value ?? 0,
    confirmNumber: entity?.confirmNumber,
});